<template>
<div id="com" class="com" v-bind:style="{ minHeight: height + 'px' }" v-if="fullRegistration">
    <div class="container">
      <div class="project-info-wrapper">
      <div class="project-title">Dashboard</div>
      </div>
      <div class="row info-row" v-if="currentUser">
        <info-block
          :editable="true"
          :showProfile="showProfile"
          :info="{
            phone_number: formatPhoneNumber(currentUser.phone),
            email_address: currentUser.email
          }"
          :title="`${currentUser.first_name} ${currentUser.last_name}`"
          :subTitle="`Joined ${formatDate(currentUser.created_at, true)}`"
          :userProfile="currentUser"
        />
        <info-block
          v-for="(item, key) in allKits"
          :key="item.kit_id"
          :info="checknull(item)"
          :title="item.title ? `${item.title}` : `Project ${key + 1}`"
          :kitId="item.kit_id"
          :userProfile="currentUser"
          :status="item.status"
          :statusLabel="item.statusLabel"
          :kitVersion="item._version"
        />
        <Profile
          v-if="showCustomerProfile"
          @closeProfile="closeProfile"
        ></Profile>
        <ActivateNewKit
          v-if="show"
          :newKitModal="newKitModal"
          @resetModal="resetModal"
          @reRenderHome="reRenderHome"
          @changeHeight="changeHeight"
        ></ActivateNewKit>
        <CommentOnHoldModal
          :comment="comment"
          v-if="commentModal"
          @closeCommentModal="closeCommentModal"
        ></CommentOnHoldModal>
      </div>
    </div>
  </div>
</template>

<script>
import InfoBlock from "./infoBlock/InfoBlock";
import Profile from "./home/Profile";
import ActivateNewKit from "./home/ActivateNewKit";
import CommentOnHoldModal from "./home/CommentOnHoldModal";
import moment from "moment";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  props: ["showCustomerProfile", "newKitModal"],
  data() {
    return {
      show: false,
      commentModal: false,
      comment: null,
      userProfile: {},
      fullRegistration: false,
      height: 630
    };
  },
  components: {
    ActivateNewKit,
    Profile,
    CommentOnHoldModal,
    InfoBlock
  },
  computed: {
    ...mapGetters(["currentUser"]),
    allKits() {
      if (!this.currentUser) return [];
      const v1 = (this.currentUser.testkits || []).map(k => ({ ...k, _version: 1 }));
      const v2 = (this.currentUser.kits_v2 || []).map(k => {
        const status = this.v2StatusToString(k.status);
        return {
          ...k,
          _version: 2,
          status,
          statusLabel: this.v2StatusLabel(status)
        };
      });
      return [...v1, ...v2];
    }
  },
  methods: {
    ...mapActions(["profile", "testuserdetails"]),
    closeCommentModal(boolean) {
      this.commentModal = boolean;
    },
    showComment(obj) {
      this.commentModal = obj.show;
      this.comment = obj;
    },
    resetModal(boolean) {
      this.show = boolean;
    },
    closeProfile(boolean) {
      this.$emit("closeProfile", boolean);
    },
    showProfile(boolean) {
      this.$emit("showProfile", boolean);
    },
    v2StatusLabel(status) {
      const labels = {
        'shipped': 'Sold',
        'activated': 'Activated',
        'lab_awaiting': 'Lab Awaiting',
        'lab_received': 'Lab Received',
        'on_hold': 'On Hold',
        'analysis_completed': 'Analysis Completed',
        'problem': 'Problematic',
        'delivered': 'Delivered',
        'archive': 'Archived',
        'returned': 'Returned',
        'analysis_failed': 'Analysis Failed',
        'partially_failed': 'Analysis Partially Failed',
        'in_active': 'Inactive'
      };
      return labels[status] || 'Sold';
    },
    v2StatusToString(status) {
      // Status may arrive as integer (from raw DB) or string (from Lucid getter)
      if (typeof status === 'string') return status;
      const map = {
        0: 'shipped', 1: 'activated', 2: 'lab_awaiting', 3: 'lab_received',
        4: 'on_hold', 5: 'analysis_completed', 6: 'problem', 7: 'delivered',
        8: 'archive', 9: 'returned', 10: 'analysis_failed', 11: 'partially_failed', 12: 'in_active'
      };
      return map[status] || 'shipped';
    },
    checknull(item){
      let sampling_loc = "";
      let sampling_col_by = "";
      // V2 kits have nested address object
      if (item._version === 2 && item.address) {
        const a = item.address;
        if (a.address && a.city && a.state && a.zip) {
          sampling_loc = `${a.address}, ${a.city}, ${a.state} ${a.zip}`;
        }
      } else if(item.address != null && item.city != null && item.state != null && item.zip != null) {
        sampling_loc = `${item.address}, ${item.city}, ${item.state} ${item.zip}`;
      }
      if(item.collected_first_name != null && item.collected_last_name != null ) {
        sampling_col_by = `${item.collected_first_name} ${item.collected_last_name}`;
      }
      return {sampling_date: this.formatDate(item.sampling_date), sampling_location: sampling_loc, sampling_collected_by: sampling_col_by};
    },
    formatDate(date, simple) {
      if (simple) return moment(date).format("MM/D/YYYY");
      else {
        const samplingDate = new Date(date);
        const options = { month: "long", day: "numeric", year: "numeric" };
        return samplingDate.toLocaleDateString("en-US", options);
      }
    },
    formatPhoneNumber(str) {
      let cleaned = ("" + str).replace(/\D/g, "");
      let match = cleaned.match(/^([1-9]|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return ["(", match[2], ") ", match[3], "-", match[4]].join("");
      }
      return null;
    },
    checkIndoorSamples(array) {
      if (
        array.confirmed_phone === null &&
        array.confirmed_email === null
      ) {
        this.$router.replace({ path: "/activate", query: { step: "2" } });
        return;
      }

      // V1 kit checks
      if (array.testkits.length > 0 && array.testkits.some(testkit => testkit.status === 'activated')) {
        const activatedKitId = array.testkits
        .filter(testkit => testkit.status === 'activated')
        .map(testkit => testkit.kit_id)
        .pop();
        if(activatedKitId) {
            this.$router.replace({ path: "/home/kit/"+activatedKitId});
            return;
        }
      } else if (array.testkits.length > 0 && (array.testkits.every(item => (item.indoorSamples.every(item2 => item2.type === null))))) {
        this.$router.replace({ path: "/activate", query: { step: "3" } });
        return;
      } else if (
        array.sampling_detail === null &&
        array.term_and_condition === null && array.testkits.length > 0
      ) {
          this.$store.dispatch("userInfo", {
            kit_id: array.testkits[0].kit_id
          });
        this.$router.replace({ path: "/activate", query: { step: "4" } });
        return;
      }

      // V2 kit: if activated but not yet submitted, resume activation flow
      const v2Kits = array.kits_v2 || [];
      const activatedV2Kit = v2Kits.find(k => k.status === 'activated' || k.status === 1);
      if (activatedV2Kit) {
        this.$store.dispatch("userInfo", activatedV2Kit);
        this.$store.commit("setKitVersionProfile", 2);
        // Fetch tempuser data so SimplingDetails can prepopulate
        this.testuserdetails(activatedV2Kit.kit_id);
        this.newKitModal.step = 1;
        this.newKitModal.kit_id = activatedV2Kit.kit_id;
        this.show = true;
        this.fullRegistration = true;
        return;
      }

      this.fullRegistration = true;
    },
    async refreshData() {
      this.userProfile = await this.profile();
      if(Object.keys(this.userProfile).length > 0) {
        this.checkIndoorSamples(this.userProfile);
      }
    },
    reRenderHome() {
      this.show = false;
      this.refreshData();
    },
    changeHeight(height) {
      this.height = height+136; 
    }
  },
  watch: {
    newKitModal() {
      this.show = true;
    }
  },
  mounted() {
    this.refreshData();
    if (localStorage.getItem("actkitid")) {
        this.show = true;
        this.newKitModal.step = 1;
        this.newKitModal.kit_id = localStorage.getItem("actkitid");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/colors";
.com {
  padding: 130px 0 60px 0;
  background-color: #f4f8f9;
  min-height: calc(100vh - 60px);
  height: auto;
  position: relative;
}
.row {
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 768px) {
  .com {
    padding: 80px 0 60px 0;
    min-height: calc(100vh - 80px);
  }
}
.container {
  .project-info-wrapper {
    width: 100%;
    font-family: TTNormsRegular, sans-serif;
    position: relative;
    display: flex;
    flex-direction: column;
    .project-title {
      width: 100%;
      height: 60px;
      background-color: $blue;
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $white;
      font-size: 28px;
    }
  }
}
.info-row {
  margin-top: 25px;
}
</style>
